import script from "./AdminOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrders.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrders.vue?vue&type=style&index=0&id=67414b22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67414b22"]])

export default __exports__